import React from 'react'
import CommonLayout from '../components/Layouts/CommonLayout'
import ChristmasPage from '../components/Xmas21'
import SocialMediaWrap from '../components/SocailMediaIcons'
import { useDimensions } from '../logic/Dimentions'
import { useSeasonal } from '../logic/Seasonal'

const Xmaspage = () => {
  const { width } = useDimensions()
  const { classes } = useSeasonal()
  return (
    <CommonLayout>
      {width >= 992 && <SocialMediaWrap classes={classes} />}
      <ChristmasPage />
    </CommonLayout>
  )
}

export default Xmaspage
